// extracted by mini-css-extract-plugin
export default {"loading":"DfrD7","product":"_2cQgq"};